import { all } from "redux-saga/effects";
import { addClusterWatcher,getAllClusterWatcher,addClinicWatcher,getAllClinicWatcher,AddPractitionerWatcher,getAllPractitionerWatcher,
    modifyClinicStatusWatcher,modifyClusterStatusWatcher,modifyPractitionerStatusWatcher,getClusterByIdWatcher,updateClusterByIdWatcher,
    getClinicByIdWatcher,updateClinicByIdWatcher,getPractitionerByIdWatcher,updatePractitionerByIdWatcher,getRolesWatcher,setRolesWatcher
 } from "../team-managment-saga";
import { getAllProgramsWatcher, programDetailsWatcher, updateProgramWatcher } from "../programs-saga";

export default function* teamManagementRootSaga() {
    yield all([
        addClusterWatcher(),
        getAllClusterWatcher(),
        addClinicWatcher(),
        getAllClinicWatcher(),
        AddPractitionerWatcher(),
        getAllPractitionerWatcher(),
        modifyClinicStatusWatcher(),
        modifyClusterStatusWatcher(),
        modifyPractitionerStatusWatcher(),
        getClusterByIdWatcher(),
        updateClusterByIdWatcher(),
        getClinicByIdWatcher(),
        updateClinicByIdWatcher(),
        getPractitionerByIdWatcher(),
        updatePractitionerByIdWatcher(),
        getRolesWatcher(),
        setRolesWatcher(),
        getAllProgramsWatcher(),
        programDetailsWatcher(),
        updateProgramWatcher()
    ])
}